// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"ff5e5eb3","963":"b93fc572"}[chunkId] + ".chunk.js";
};